import { render } from "./UkrainianChannels.vue?vue&type=template&id=4b506dd4"
import script from "./UkrainianChannels.vue?vue&type=script&lang=js"
export * from "./UkrainianChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__